import React from "react";
import ModalLayout from "../ModalLayout";
import { useDispatch, useSelector } from "react-redux";
import { Creators as OrderActions } from "../../store/ducks/order";

function DeliveryOptionExchangeModal({ actionOnExchange }) {
    const dispatch = useDispatch();
    const { error } = useSelector(state => state.order);

    const acceptExchange = () => {
        const infoCheckoutStorage = localStorage.getItem("@ConexaoGAM:checkout");
        
        if (infoCheckoutStorage) {
            const checkout = JSON.parse(infoCheckoutStorage);
            checkout.dadosEntrega.subtipoEntrega = undefined;
            localStorage.setItem("@ConexaoGAM:checkout", JSON.stringify(checkout));
        }
        actionOnExchange();
        handleCloseModal();
    }

    const handleCloseModal = () => {
        dispatch(OrderActions.resetError())
    }

    return (
        <ModalLayout
            showModal={error && error.type === "ERROR_DELIVERY_TYPE_EXPRESS_NOT_AVAILABLE" && error.visible}
            title="Entrega expressa indisponível"
            handleCloseModal={handleCloseModal}
            buttonLeft={{ text: "Sim", action: acceptExchange }}
            buttonRight={{ text: "Não", action: handleCloseModal }}
        >
            <p>Infelizmente a farmácia não está com a opção de entrega expressa disponível.</p>
            <p>Você aceitar trocar a entrega expressa por entrega comum?</p>
        </ModalLayout >
    );
}

export default DeliveryOptionExchangeModal;